<form class="form-check mat-form" [formGroup]="form">
    <table class="table table-sm">
        <thead class="thead-dark">
            <tr class="d-flex">
            <th >Name</th>
            <th >Ref</th>
            <th >Desc</th>
            <th >Allocated %</th>
            <th >Allocated value</th>
            <th ></th>
            </tr>
        </thead>
        <tbody formArrayName="children">
            <tr *ngFor="let arr of childrenArray.controls; let i=index; let lst=last; let fst = first" [formGroupName]="i"
                >
                <td >
                    <mat-form-field class="mat-field-width">
                        <input matInput
                                formControlName="name"
                                placeholder="Name"
                                [errorStateMatcher]="errorMatcher" />
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                </td>
                <td >
                    <mat-form-field class="mat-field-width">
                        <input matInput
                                formControlName="ref"
                                placeholder="Ref"
                                [errorStateMatcher]="errorMatcher" />
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                </td>
                <td >
                    <mat-form-field class="mat-field-width">
                        <input matInput
                                formControlName="description"
                                placeholder="Description"
                                [errorStateMatcher]="errorMatcher" />
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                </td>
                <td >
                    <mat-form-field class="mat-field-width">
                        <input matInput
                                formControlName="allocation"
                                [errorStateMatcher]="errorMatcher" />
                        <span matSuffix class="currency-add-on">%</span>
                        <mat-error>Value between 0 &amp; 100</mat-error>
                    </mat-form-field>
                </td>
                <td >
                    <mat-form-field class="mat-field-width">
                        <input matInput
                                formControlName="value"
                                [errorStateMatcher]="errorMatcher" />
                        <span matPrefix class="currency-add-on">{{currency | currencySymbol}}</span>
                    </mat-form-field>
                </td>
                <td >
                    <button mat-icon-button *ngIf="lst" (click)="addChild()"
                            title="Add new kit member">
                        <mat-icon>add_circle</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="!fst" (click)="removeChild(i)"
                            title="Remove kit member">
                        <mat-icon>clear</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <th colspan="2">
                    <span *ngIf="!moreThanOneChild" class="mat-warn">
                        You must have more than one child to create a kit
                    </span>
                </th>
                <th >Totals:</th>
                <th >
                    <mat-form-field class="mat-field-width">
                        <input matInput 
                            formControlName="allocationTotal"
                            [errorStateMatcher]="errorMatcher" />
                        <span matSuffix class="currency-add-on">%</span>
                        <mat-error>Value between 0 &amp; 100</mat-error>
                    </mat-form-field>
                    
                </th>
                <th >
                    <mat-form-field class="mat-field-width">
                        <input matInput 
                            formControlName="currentValueTotal"
                            [errorStateMatcher]="errorMatcher" />
                        <span matPrefix class="currency-add-on">{{currency | currencySymbol}}</span>
                        <mat-error>Must equal {{value}}</mat-error>
                    </mat-form-field>
                </th>
                <th ></th>
            </tr>
        </tfoot>
    </table>
  </form>